export const liveReportingQueryKeys = {
  root: (actorId: string | undefined, organizationId: string | undefined) =>
    ['liveReporting', actorId, organizationId] as const,
  summaries: (
    actorId: string | undefined,
    organizationId: string | undefined,
  ) =>
    [
      ...liveReportingQueryKeys.root(actorId, organizationId),
      'summaries',
    ] as const,
  result: (
    actorId: string | undefined,
    organizationId: string | undefined,
    reportId: string | undefined,
    segment: 'live' = 'live',
  ) =>
    [
      ...liveReportingQueryKeys.root(actorId, organizationId),
      'result',
      reportId,
      segment,
    ] as const,
}

export const liveReportingCacheScope = (
  actorId: string | undefined,
  organizationId: string | undefined,
) => liveReportingQueryKeys.root(actorId, organizationId)
